import { Button, Divider, Stack, styled } from "@mui/material";
import { API } from "aws-amplify";
import { customColors } from "models/customColors";
import { useContext, useEffect, useState } from "react";
import { useAppDispatch } from "store/hooks";
import { showError } from "store/reducers/errorReducer";
import { CommonOutletTemplate } from "UI/CommonOutletTemplate";
import AddCardForm from "./AddCardPhorm";
import { ModalSpinner } from "./ModalSpinner";
import { GlobalContext } from "store/globalContext";

// const Title = styled(Box)`
//   font-weight: 500;
// `;

const Paper = styled(Stack)`
  padding: 23px 39px;

  border-radius: 13px;
  border: 1px solid #dfdfdf;
  background-color: ${customColors.white};
`;

export const PaymentMethods = () => {
  const dispatch = useAppDispatch();
  const { userData } = useContext(GlobalContext);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const isPaymentMethodExists = !!paymentMethod?.stripePaymentMethodId;
  const [showAddCardForm, setShowAddCardForm] = useState(false);

  const loadPaymentMethods = async () => {
    try {
      const result = await API.get(
        "restApiV2",
        "/payment/payment-data/by-user",
        {}
      );
      setPaymentMethod(result);
    } catch (error) {
      dispatch(showError(error?.message));
    } finally {
      setIsLoaded(true);
    }
  };

  const reloadAfterAddCard = () => {
    loadPaymentMethods();
    setShowAddCardForm(false);
  };

  useEffect(() => {
    loadPaymentMethods();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  return (
    <CommonOutletTemplate title="Payment Method">
      {isLoaded ? (
        <Paper flex={1} mt={2} mb={1}>
          {isPaymentMethodExists ? (
            <>
              <div className="mt-6 flex flex-row gap-4 flex-wrap">
                <p>
                  Credit Card:{" "}
                  <strong>**** **** **** {paymentMethod?.card?.last4}</strong>
                </p>
                <p>
                  Type:{" "}
                  <strong>{paymentMethod?.card?.brand?.toUpperCase()}</strong>
                </p>
                <p>
                  Expires:{" "}
                  <strong>
                    {paymentMethod?.card?.expMonth}/
                    {paymentMethod?.card?.expYear}
                  </strong>
                </p>
              </div>
              <p className="text-gray-600 my-8 text-sm">
                Your card is saved and ready for future transactions. For your
                security, only the last four digits are visible.
              </p>
              {showAddCardForm ? (
                <>
                  <Divider />
                  <p className="text-gray-600 mt-4 mb-8 text-sm">
                    Please update your card details for future billing related
                    to referral services. This card will be securely saved and
                    used for any upcoming payments required during the referral
                    process.
                  </p>
                  <div className="flex flex-col items-center lg:items-start">
                    <div className="w-full max-w-96">
                      <AddCardForm
                        reloadAfterAddCard={reloadAfterAddCard}
                        isPaymentMethodExists={isPaymentMethodExists}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <div>
                  <Button
                    variant="outlined"
                    onClick={() => setShowAddCardForm(true)}
                  >
                    Add another card
                  </Button>
                </div>
              )}
            </>
          ) : (
            <>
              <p className="text-gray-600 mb-8 text-sm">
                Please add your card details for future billing related to
                referral services. This card will be securely saved and used for
                any upcoming payments required during the referral process.
              </p>
              <div className="flex flex-col items-center lg:items-start">
                <div className="w-full max-w-96">
                  <AddCardForm
                    reloadAfterAddCard={reloadAfterAddCard}
                    isPaymentMethodExists={isPaymentMethodExists}
                  />
                </div>
              </div>
            </>
          )}
        </Paper>
      ) : (
        <ModalSpinner open />
      )}
    </CommonOutletTemplate>
  );
};
